module.exports = __webpack_public_path__ + "img/home web.c52c9147.png";